/* GENERATED by scripts/gen-data.mjs — chapter "bonus-pipeline" (from s2.js + s3.js).
 * Structure only: every string is an i18n key resolved from
 * src/i18n/locales/<lang>/. Edit the content in the artifact and re-run
 * npm run extract, do not hand-edit here. */

import type { NodeDef } from '../../types';

export const N_BONUS_PIPELINE: NodeDef = {
  "id": "bonus-pipeline",
  "tagKey": "path:bonus-pipeline.tag",
  "x": 656,
  "y": 870,
  "w": 176,
  "h": 88,
  "titleKey": "path:bonus-pipeline.title",
  "subKey": "path:bonus-pipeline.sub",
  "blocks": [
    {
      "id": "bonus-pipeline.b1",
      "kind": "game",
      "xp": 120,
      "titleKey": "path:bonus-pipeline.b1.title",
      "bodyKey": "path:bonus-pipeline.b1.body",
      "flowKey": "path:bonus-pipeline.b1.flow"
    }
  ],
  "extra": true,
  "bonus": true
};
